module.exports = __webpack_public_path__ + "img/gift4-01-c09-k1.d5d8b6b8.png";